import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-[var(--cb-bg)] p-4">
          <div className="bg-white rounded-2xl shadow-xl p-6 max-w-sm w-full text-center">
            <div className="text-4xl mb-3">🐛</div>
            <h2 className="text-lg font-bold text-[var(--cb-text)] mb-2">
              {this.props.language === 'fr' ? 'Oups, une erreur est survenue' : 'Oops, an error occurred'}
            </h2>
            <p className="text-sm text-[color:var(--cb-text-muted)] mb-4">
              {this.props.language === 'fr'
                ? 'Veuillez rafraîchir la page ou réessayer plus tard.'
                : 'Please refresh the page or try again later.'}
            </p>
            <button
              onClick={() => {
                this.setState({ hasError: false, error: null });
                window.location.reload();
              }}
              className="px-4 py-2 bg-[var(--cb-accent)] text-white rounded-lg font-semibold hover:opacity-90 transition-opacity"
            >
              {this.props.language === 'fr' ? 'Rafraîchir' : 'Refresh'}
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
